import { GridColDef } from '@mui/x-data-grid-pro';

export const companyViewColumns: GridColDef[] = [
  { 
    field: 'company_sid',
    type: 'string',
    headerName: 'Company SID',
    width: 150,
  },
  { 
    field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 250,
  },
  { 
    field: 'parent_company_name',
    type: 'string',
    headerName: 'Parent Company',
    width: 200,
  },
  { 
    field: 'dba_name',
    type: 'string',
    headerName: 'DBA Name',
    width: 200,
  },
  { 
    field: 'city',
    type: 'string',
    headerName: 'City',
    width: 150,
  },
  { 
    field: 'state',
    type: 'string',
    headerName: 'State',
    width: 100,
  },
  { 
    field: 'postal_code',
    type: 'string',
    headerName: 'Postal Code',
    width: 125,
  },
  { 
    field: 'naics_code',
    type: 'string',
    headerName: 'NAICS',
    width: 100,
  },
  { 
    field: 'phone',
    type: 'string',
    headerName: 'Phone',
    width: 125,
  },
  { 
    field: 'representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 175,
  },
  { 
    field: 'representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 200,
  },
  { 
    field: 'is_deleted',
    type: 'boolean',
    headerName: 'Deleted',
    width: 120,
    valueFormatter: (params) => params.value ? 'Yes' : 'No',
  },
  { 
    field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];
